import { useQuery } from "react-query";
import { APIResponse, get,API_URL_V3 } from "../api";


export interface SurveyStatusData {
  has_submitted: boolean;
  submitted_at: string | null;
}

/**
 * GET /onboarding-survey/status
 * Check whether the authenticated user has already submitted the onboarding survey.
 */
function useOnboardingSurveyStatus(options?: { enabled?: boolean }) {
  const token = localStorage.getItem("token");

  const {
    data,
    isLoading: checkingStatus,
    isError: isStatusError,
    error: statusError,
    refetch: refetchStatus,
  } = useQuery<APIResponse<SurveyStatusData>, Error>(
    ["onboarding_survey_status"],
    () =>
      get(`${API_URL_V3}/onboarding-survey/status`, {
        headers: {
          Accept: "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      }),
    {
      // Only run if there's a token present
      enabled: options?.enabled !== undefined ? options.enabled : !!token,
      // Don't retry on 401/422 — user may simply not be authenticated yet
      retry: false,
      // Cache for 5 minutes — survey status won't change often
      staleTime: 1000 * 60 * 5,
    }
  );

  const hasSubmitted = data?.data?.has_submitted ?? false;
  const submittedAt = data?.data?.submitted_at ?? null;

  return {
    hasSubmitted,
    submittedAt,
    checkingStatus,
    isStatusError,
    statusError,
    refetchStatus,
  };
}

export default useOnboardingSurveyStatus;
